<template>

    <div class="background">
        <div class="container">
            <img class="headerLogo" src="../assets/logo.png">
            <img class="apple download" src="../assets/DownloadByAppStore.png" v-on:click="say('https://itunes.apple.com/cn/app/id1332575155?mt=8')">
            <img class="google download" src="../assets/DownloadByGooglePlay.png" v-on:click="say('https://play.google.com/store/apps/details?id=com.luciditv.xfzhi')">
            <img class="cjxf download" src="../assets/DownloadByLuciditv.png" v-on:click="say(androidDownloadUrl)">
         
            <el-button class="cjxf download copylink" type="info" @click="copyLink">複製APK連結到剪貼簿</el-button>
            <!-- <img class="mac download" src="../assets/button_download_desktop.png" v-on:click="say('https://17up.luciditv.app/')"> -->
            <img class="windows download" src="../assets/button_download_windows.png" v-on:click="pcDownload('win')">
            <img class="mac download" src="../assets/button_download_mac.png" v-on:click="pcDownload('mac')">

            <div class="bottomText">洪鐘初叩醒覺三千界．二障盡除澈見本性空</div>
        </div>
        <div class="rightText">
            ©2017 澈見網路電視台 All Rights Reserved.</div>
    </div>
</template>

<script>
  export default {
    name: 'Download',
    props: {
      msg: String,
    },
    methods:{
      copyLink(){
        const el = document.createElement('textarea');  
        el.value = this.androidDownloadUrl;
         el.setAttribute('readonly', '');                
        el.style.position = 'absolute';                     
        el.style.left = '-9999px';                      
        document.body.appendChild(el);  
        el.select();
        el.setSelectionRange(0, 99999)
        document.execCommand("copy");
        document.body.removeChild(el);
         this.$message({
          message: '已複製成功',
          type: 'success'
        });
      },
      say: function (message) {
        window.location.href = message;
      },
      pcDownload(type){
        switch(type){
          case 'mac':
            this.say(this.pcDownloadUrl+this.macFileName)
            break;
          case 'win':
            this.say(this.pcDownloadUrl+this.winFileName)
            break;
        }

      },
      getMacFile() {
      const yaml = require("js-yaml");
      this.$axios
        .get(this.pcDownloadYmlUrl+"release-mac.yml")
        .then((res) => {
          let data = res.data;
          const doc = yaml.safeLoad(data);
          for (let i = 0; i < doc.files.length; i++) {
            if (doc.files[i].url.includes(".dmg")) {
              console.log("getMacFile:" + doc.files[i].url);
              this.macFileName = doc.files[i].url;
            }
          }
        })
        .catch((e) => {
          console.log(JSON.stringify(e));
        });
    },
    getWinFile() {
      const yaml = require("js-yaml");
      this.$axios
        .get(this.pcDownloadYmlUrl+"release.yml")
        .then((res) => {
          let data = res.data;
          const doc = yaml.safeLoad(data);
          for (let i = 0; i < doc.files.length; i++) {
            if (doc.files[i].url.includes(".exe")) {
              console.log("getWinFile:" + doc.files[i].url);
              this.winFileName = doc.files[i].url;
            }
          }
        })
        .catch((e) => {
          console.log(JSON.stringify(e));
        });
    },
    },
    created: async function () {
      // console.log('这是资料详情');
      const response = await this.$axios.get('/system/getLatestAndroidVersion');
      this.dataInfoObject = response.data.data;
      // console.log(response.data.data.versionApkUrl);
      // versionApkUrl: "http://cj-app.oss-ap-southeast-1.aliyuncs.com/mobile/apk/app-release.apk"
      // versionCode: 30013
      // versionInfoPoint: "android 3.0.13"
      // versionType: 0
      this.androidDownloadUrl = response.data.data.versionApkUrl;
        this.getMacFile();
        this.getWinFile();
    },
    data: function () {
      return {
        androidDownloadUrl: String,
        winFileName: String,
        macFileName: String,
        pcDownloadUrl:'https://17up.luciditv.app/release/',
        pcDownloadYmlUrl:'https://cjxf-desktop.s3-ap-southeast-1.amazonaws.com/release/'
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

    .background{
        background-color: rgba(242,242,242,1);
        /*width: 100vw;*/
        /*height: 100vh;*/
        @media only screen and (min-height: 648px) {
            height: 100vh;
        }
        display: flex;
        flex-direction: column;

        .container{
            flex-grow: 1;
            margin: 20px 20px 0px 20px;
            width: calc(100vw - 40px);
            background-color: rgba(255,255,255,1);
            box-shadow:0px 2px 4px 0px rgba(0,0,0,0.5);
            display: flex;
            align-items: center;
            flex-direction: column;

            .headerLogo{
                margin-top: 40px;
                width: 128px;
                height: 128px;
            }

            .download {
                width: 275px;
                height: 60px;
            }
            .cjxf.download.copylink{
              margin-top: 10px;
              font-size: 20px;
              background-color: #595959;
              border-color: #595959;
            }
            .apple{
                margin-top: 40px;
            }

            .google{
                margin-top: 20px;
            }

            .cjxf{
                margin-top: 20px;
            }

            .mac{
                margin-top: 20px;
            }

            .windows{
                margin-top: 20px;
            }

            .bottomText{
                width:266px;
                height:20px;
                font-size:14px;
                font-weight:400;
                color:rgba(89,89,89,1);
                line-height:20px;
                margin-bottom: 10px;
                @media only screen and (min-height: 648px) {
                    margin-top: auto;
                }

                @media only screen and (max-height: 648px) {
                    margin-top: 94px;
                }
            }
        }

        .rightText{
            /*display: flex;*/
            width:239px;
            height:17px;
            font-size:12px;
            font-weight:400;
            color:rgba(140,140,140,1);
            line-height:17px;
            margin-right: auto;
            margin-left: auto;
            margin-bottom: 10px;
            margin-top: 10px;
        }
    }
</style>
